import React from 'react';

import strings from '../../Localization/Localization';

import MainLayout from '../Layout/MainLayout';

import '../../css/credit_center.css';

import { Container, Row, Col, InputGroup, Form } from 'react-bootstrap';

import Loading from '../Layout/Loading';

import Tabs from '../Tabs/Tabs';
import Tab from '../Tabs/Tab/Tab';

import Table from '../Table/Table';
import TableHeader from '../Table/TableHeader';
import TableBody from '../Table/TableBody';
import TableTextHeader from '../Table/Header/TableTextHeader';
import TableRow from '../Table/Body/TableRow';

import StringCell from '../Form/Field/TableCell/StringCell';
import IntegerCell from '../Form/Field/TableCell/IntegerCell';
import FloatCell from '../Form/Field/TableCell/FloatCell';
import PriceCell from '../Form/Field/TableCell/PriceCell';

import { withModalHandler } from '../../HOC/ModalHandler';
import { fetchAvailableCreditPacks } from '../../API/CreditPacks';
import { index as partnerIndex } from '../../API/Partners';
import { index as boughtCreditAmountsIndex } from '../../API/BoughtCreditAmounts';
import { index as usedCreditAmountsIndex } from '../../API/UsedCreditAmounts';
import { index as giftedCreditAmountsIndex } from '../../API/GiftedCreditAmounts';
import { index as orderedCreditAmountsIndex } from '../../API/OrderedCreditAmounts';

import CreditPackElement from './CreditPackElement';

import { timeframe } from '../../MetaData/Form/common';
import { processTimeframe } from '../../MetaData/Configuration/common';

import {
	technicalTicket as technicalTicketRoutes,
	users as usersRoutes,
	orders as ordersRoutes
} from '../../MetaData/Route/routes';

class CreditCenter extends React.Component {

	constructor(props){
    super(props);

		this.timeframeOptions = timeframe.compute(false, false);

    this.state = {
			tabsKey: "pack",

			loadingPartner: true,
			loadingCreditPacks: true,

			partners: null,
			selectedPartner: "",
			selectedPartnerAccount: "",

      creditPacks: null,

			boughtCreditAmounts: null,
			usedCreditAmounts: null,
			giftedCreditAmounts: null,
			orderedCreditAmounts: null,

			selectedTimeframe: "currentMonth"
    }

		this.fetchAvailableCreditPacks = this.props.modalHandler.addVerificationWithCallback(fetchAvailableCreditPacks, this.updateCreditPacks);
		this.partnerIndex = this.props.modalHandler.addVerificationWithCallback(partnerIndex, this.updatePartners);

		this.boughtCreditAmountsIndex = this.props.modalHandler.addVerificationWithCallback(boughtCreditAmountsIndex, this.updateBoughtCreditAmountHistory);
		this.usedCreditAmountsIndex = this.props.modalHandler.addVerificationWithCallback(usedCreditAmountsIndex, this.updateUsedCreditAmounts);
		this.giftedCreditAmountsIndex = this.props.modalHandler.addVerificationWithCallback(giftedCreditAmountsIndex, this.updateGiftedCreditAmounts);
		this.orderedCreditAmountsIndex = this.props.modalHandler.addVerificationWithCallback(orderedCreditAmountsIndex, this.updateOrderedCreditAmounts);

  }

	/**
   * Once the component is mounted, we can query for the first page of data
   */
  componentDidMount(){
    this.fetchAvailableCreditPacks();
		this.partnerIndex(1, 0, {}, 'ASC', 'credit');
  }

	/**
   * collect the result of the query and update the state of the component to
   * display the new set of data
   *
   * @param data the data of the query
   */
  updateCreditPacks = (data) => {
    this.setState({
			loadingCreditPacks: false,

      creditPacks: data.items
    })
  }

	/**
   * collect the result of the query and update the state of the component to
   * display the new set of data
   *
   * @param data the data of the query
   */
  updatePartners = (data) => {
		console.log(data.items);
    this.setState({
			loadingPartner: false,

      partners: data.items,
			selectedPartner: data.items.length > 0?data.items[0]:"",
			selectedPartnerAccount: data.items.length > 0?data.items[0].accounts[0]:""
    })
  }

	updateBoughtCreditAmountHistory = (data) => {
    this.setState({
			loadingCreditAmounts: this.state.loadingCreditAmounts -1,
      boughtCreditAmounts: data.items,
    })
  }

	updateUsedCreditAmounts = (data) => {
    this.setState({
			loadingCreditAmounts: this.state.loadingCreditAmounts -1,
      usedCreditAmounts: data.items,
    })
  }

	updateGiftedCreditAmounts = (data) => {
    this.setState({
			loadingCreditAmounts: this.state.loadingCreditAmounts -1,
      giftedCreditAmounts: data.items,
    })
  }

	updateOrderedCreditAmounts = (data) => {
    this.setState({
			loadingCreditAmounts: this.state.loadingCreditAmounts -1,
      orderedCreditAmounts: data.items,
    })
  }


	loadAllCreditAmounts() {
		let search = {}

		let createdAtTimeframe = processTimeframe({ value: this.state.selectedTimeframe });

		search["client_credit_amount"] = this.state.selectedPartnerAccount["client_credit_amount"]["id"];
		search["created_at_min"] = createdAtTimeframe.min;
		search["created_at_max"] = createdAtTimeframe.max;

		this.setState({
			loadingCreditAmounts: 4
		}, () => {
			this.boughtCreditAmountsIndex(1, 0, search)
			this.usedCreditAmountsIndex(1, 0, search)
			this.giftedCreditAmountsIndex(1, 0, search)
			this.orderedCreditAmountsIndex(1, 0, search)
		})
	}

	changeTab = (key) => {
		if(key === "history") {
			this.loadAllCreditAmounts();
		}
    this.setState({
      tabsKey: key
    })
  }

	displayCurrentCreditAmount() {
		if(!this.state.loadingPartner) {
			return(
				<Container>
					<Row className="justify-content-center">
						<Col className="credit-center-main-container" xs={10}>
							<Row className="credit-center-main-container-inner">
								<Col xs={8}>
									<Row className="credit-center-partner-choice-row">
										<InputGroup className={`container-form-row container-form-row-colored col-12`}>
											<InputGroup.Prepend
												className="d-none d-md-flex col-md-4 container-form-prepend">
												<InputGroup.Text className="col-md-12">
													{strings.creditPack.creditCenter.partner}
												</InputGroup.Text>
											</InputGroup.Prepend>
											<Form.Control
												as="select"
												className="d-flex col-12 col-md-8 col-border-radius col-md-border-radius"
												placeholder={strings.creditPack.creditCenter.partner}
												aria-label={strings.creditPack.creditCenter.partner}
												type="text"
												disabled={this.state.partners.length < 2}
												value={this.state.selectedPartner?this.state.selectedPartner.name:""}
												onChange={(event) => {
													let selectedPartner = this.state.partners.find(partner => partner.name === event.target.value)
													this.setState({
														selectedPartner: selectedPartner,
														selectedPartnerAccount: selectedPartner.accounts[0]
													}, () => {
														if(this.state.tabsKey === "history") {
															this.loadAllCreditAmounts();
														}
													})
												}}
											>
												{this.state.partners.map((partner, i) => {
													return (
														<option key={i} value={partner.name} label={partner.name}>{partner.name}</option>
													)
												})}
											</Form.Control>
										</InputGroup>
									</Row>
									<Row className="credit-center-partner-choice-row">
										<InputGroup className={`container-form-row container-form-row-colored col-12`}>
											<InputGroup.Prepend
												className="d-none d-md-flex col-md-4 container-form-prepend">
												<InputGroup.Text className="col-md-12">
													{strings.creditPack.creditCenter.partnerAccount}
												</InputGroup.Text>
											</InputGroup.Prepend>
											<Form.Control
												as="select"
												className="d-flex col-12 col-md-8 col-border-radius col-md-border-radius"
												placeholder={strings.creditPack.creditCenter.partnerAccount}
												aria-label={strings.creditPack.creditCenter.partnerAccount}
												type="text"
												disabled={this.state.selectedPartner === "" || this.state.selectedPartner.accounts.length < 2}
												value={(this.state.selectedPartnerAccount && this.state.selectedPartnerAccount["partner_type"])?this.state.selectedPartnerAccount["partner_type"].name:""}
												onChange={(event) => {
													let selectedPartnerAccount = this.state.selectedPartner.accounts.find(account => account["partner_type"].name === event.target.value)
													this.setState({
														selectedPartnerAccount: selectedPartnerAccount
													}, () => {
														if(this.state.tabsKey === "history") {
															this.loadAllCreditAmounts();
														}
													})
												}}
											>
												{this.state.selectedPartner?this.state.selectedPartner.accounts.map((account, i) => {
													return (
														<option key={i} value={account["partner_type"].name} label={account["partner_type"].name}>{account["partner_type"].name}</option>
													)
												}):null}
											</Form.Control>
										</InputGroup>
									</Row>
								</Col>
								<Col xs={4}>
									<Row>
										<Col xs={12} className="d-flex justify-content-end">
											{strings.creditPack.creditCenter.amount}
										</Col>
									</Row>
									<Row>
										<Col xs={12} className="d-flex justify-content-end">
											<Row>
												<div className="credit-center-credit-amount">{this.state.selectedPartnerAccount["client_credit_amount"]["current_amount"]}</div><i className="icon-kredits-icons"/>
											</Row>
										</Col>
									</Row>
								</Col>
							</Row>
						</Col>
					</Row>
				</Container>
			)
		}
	}

	displayCreditPackSelection() {
		if(!this.state.loadingCreditPacks) {
			return (
				<Container>
					<Row className="justify-content-center">
						<Col className="credit-center-main-container" xs={10}>
							<Row className="credit-center-main-container-inner justify-content-center">
								{this.state.creditPacks.map((creditPack, i) => {
									return (
										<CreditPackElement
											key={i}
											creditPack={creditPack}
											onClickAdd={(creditPack) => console.log(creditPack)}/>
									)
								})}
							</Row>
						</Col>
					</Row>
				</Container>
			)
		}
	}

	displayHistory() {
		let history = [];
		if(this.state.boughtCreditAmounts && this.state.usedCreditAmounts && this.state.giftedCreditAmounts && this.state.orderedCreditAmounts) {
			history = [
				...this.state.boughtCreditAmounts.map(boughtCreditAmount => Object.assign({ sourceType: "bought" }, boughtCreditAmount)),
				...this.state.usedCreditAmounts.map(usedCreditAmount => Object.assign({ sourceType: "appointment" }, usedCreditAmount)),
				...this.state.giftedCreditAmounts.map(giftedCreditAmount => Object.assign({ sourceType: "gift" }, giftedCreditAmount)),
				...this.state.orderedCreditAmounts.map(orderedCreditAmount => Object.assign({ sourceType: "order" }, orderedCreditAmount))
			].sort((a, b) => a["created_at"] < b["created_at"])
		}

		return (
			<Container className="d-flex justify-content-center">
				<Col className="justify-content-center" xs={10}>
					<Row className="credit-center-history-row-timeframe">
						<InputGroup className={`container-form-row container-form-row-colored col-12`}>
							<InputGroup.Prepend
								className="d-none d-md-flex col-md-4 container-form-prepend">
								<InputGroup.Text className="col-md-12">
									{strings.creditPack.creditCenter.timeframe}
								</InputGroup.Text>
							</InputGroup.Prepend>
							<Form.Control
								as="select"
								className="d-flex col-12 col-md-8 col-border-radius col-md-border-radius"
								placeholder={strings.creditPack.creditCenter.timeframe}
								aria-label={strings.creditPack.creditCenter.timeframe}
								type="text"
								value={this.state.selectedTimeframe}
								onChange={(event) => {
									this.setState({
										selectedTimeframe: event.target.value,
									}, () => {
										this.loadAllCreditAmounts();
									})
								}}
							>
								{this.timeframeOptions.map((option, i) => {
									return (
										<option key={i} value={timeframe.adapter.getValue(option)} label={timeframe.adapter.getLabel(option)}>{timeframe.adapter.getLabel(option)}</option>
									)
								})}
							</Form.Control>
						</InputGroup>
					</Row>

					{this.state.loadingCreditAmounts === 0?
						<Table
							cellCollection={{
								string: StringCell,
								integer: IntegerCell,
								float: FloatCell,
								price: PriceCell
							}}>
							<TableHeader>
								<TableTextHeader
									value={(data) => {
										switch (data.sourceType) {
											case "appointment":
												return "Intervention";
											case "gift":
												return "Cadeau";
											case "bought":
												return "Achat";
											case "order":
												return "Commande";
											default:
												return "-";
										}
									}}
									label="Type"
									type="string"/>
								<TableTextHeader
									value={(data) => {
										switch (data.sourceType) {
											case "appointment":
												return data.appointment.number;
											case "gift":
												return data.comment;
											case "bought":
												return data.user.displayName;
											case "order":
												return data.cart_item.cart.order.number;
											default:
												return "-";
										}
									}}
									label="Source"
									type="string"
									href={(data) => {
										switch (data.sourceType) {
											case "appointment":
												return technicalTicketRoutes.routes.show.createPath(data.appointment.ticket.id);
											case "gift":
												return "#";
											case "bought":
												return usersRoutes.routes.show.createPath(data.user.id);
											case "order":
												return ordersRoutes.routes.show.createPath(data.cart_item.cart.order.id);
											default:
												return "#";
										}
									}}/>
								<TableTextHeader
									value="created_at"
									label="Date"
									type="string"/>
								<TableTextHeader
									value={(data) => {
										switch (data.sourceType) {
											case "appointment":
												return "-";
											case "gift":
												return data.quantity;
											case "bought":
												return data.quantity;
											case "order":
												return data.quantity;
											default:
												return "-";
										}
									}}
									label="Montant ajouté"
									type="string"/>
								<TableTextHeader
									value={(data) => {
										switch (data.sourceType) {
											case "appointment":
												return data.quantity;
											case "gift":
												return "-";
											case "bought":
												return "-";
											case "order":
												return "-";
											default:
												return "-";
										}
									}}
									label="Montant retiré"
									type="string"/>
							</TableHeader>
							<TableBody>
								{history.map((data, i) => {
									return (
										<TableRow key={i} data={data}/>
									)
								})}
							</TableBody>
						</Table>
					:null}

				</Col>
			</Container>
		)
	}

	displayTabs() {
		return (
			<Tabs activeKey={this.state.tabsKey} onSelect={this.changeTab} id="tabs-users">
				<Tab eventKey="pack" title="PACK" icon="icon-cart">
					{this.displayCreditPackSelection()}
				</Tab>
				<Tab eventKey="history" title="HISTORIQUE" icon="icon-time-reverse">
					{this.displayHistory()}
				</Tab>
			</Tabs>
		)
	}

	displayLoading() {
    if(this.state.loadingCreditPacks || this.state.loadingPartner) {
      return (
        <Loading/>
      )
    }
  }

  render() {
    return (
			<MainLayout>
				{this.displayLoading()}
				{this.displayCurrentCreditAmount()}
				{this.displayTabs()}
			</MainLayout>
    );
  }
}

export default withModalHandler(CreditCenter);
